import module from 'nominas/nomina/module.js'
import template from './template.html'
import { isDate } from 'lodash'

export class NominasNominaInformacionConfiguracionEditarPeriodoComponent {
  data
  status

  $onInit () {
    if (this.data && isDate(this.data.fecha)) {
      let fecha = this.data.fecha

      this.fechaMin = new Date(fecha.getFullYear(), fecha.getMonth(), 1)
      this.fechaMax = new Date(fecha.getFullYear(), fecha.getMonth() + 1, 0)
    }
  }
}

module.component('nominasNominaInformacionConfiguracionEditarPeriodo', {
  controller: NominasNominaInformacionConfiguracionEditarPeriodoComponent,
  template,
  bindings: {
    data: '<',
    status: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/informacion/configuracion/editar/periodo/component.js